import { createComponentStore } from './createComponentStore';
export const useProcedureStageComponentStore = createComponentStore('procedureStageComponent');
